import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
	getShareDetailUser,
	revokeShare,
	resendShare,
} from "../actions/shareActions";

import { PublicSharePageBase } from "./Share.js";

import { ButtonWithIcon } from "./ButtonWithIcon";

import { openValueCopyDialog } from "../actions/globalEditDialogActions";

import { mediumDateFormat } from "../utilities/utilities";

import ScrollableListOfFiles from "./ScrollableListOfFiles";
import { IconCancel, IconShare2 } from "@tabler/icons-react";
import {
	getActionDisableMessage,
	getResendButtonText,
} from "./ExternalSharingUtils.js";
import InfoRow from "./InfoRow.js";

const PropertyValue = (propertyName, value) => {
	return (
		<div style={{ marginLeft: 12, marginBottom: 12 }}>
			<span style={{ fontFamily: "MainFont-Bold", marginRight: 12 }}>
				{propertyName}
			</span>
			<span>{value}</span>
		</div>
	);
};

class ShareDetail extends Component {
	constructor(props, context) {
		super(props, context);

		this.refresh = this.refresh.bind(this);
	}
	refresh() {
		if (this.props.match.params.shareID) {
			this.props.getShareDetailUser({
				shareID: this.props.match.params.shareID,
			});
		} else if (this.props.match.params.accessHash) {
			this.props.getShareDetailUser({
				accessHash: this.props.match.params.accessHash,
				externalShareRegion:
					this.props.match.params.externalShareRegion,
			});
		}
	}

	componentDidMount() {
		this.refresh();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.match.params.shareID !== this.props.match.params.shareID
		) {
			this.refresh();
		}
	}

	render() {
		return this.props.loading ? null : this.props.publicSharePage ? (
			<div>
				<PublicSharePageBase />
			</div>
		) : (
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
					gridGap: 50,
				}}
			>
				<div style={{ position: "relative", minWidth: 0 }}>
					<div>
						{PropertyValue("Share ID", this.props.shareDetails.id)}
						{PropertyValue(
							"Sender",
							this.props.shareDetails.senderName
						)}
						{PropertyValue(
							"Date/Time Sent",
							mediumDateFormat(
								this.props.shareDetails.lastEmailSentDate
							)
						)}
						{PropertyValue(
							"Expires",
							mediumDateFormat(this.props.shareDetails.expDate)
						)}
						{PropertyValue(
							"Share Status",
							this.props.shareDetails.displayStatus
						)}
						{PropertyValue(
							"Download Link",
							<Link
								to="#"
								onClick={() => {
									this.props.openValueCopyDialog(
										this.props.shareDetails.downloadURL,
										"Share Download Link",
										"Download Link Copied to Clipboard"
									);
								}}
							>
								View
							</Link>
						)}

						{PropertyValue(
							"Matter",
							this.props.shareDetails
								.matterWasPermanentlyDeleted ? (
								<>{this.props.shareDetails.matterName}</>
							) : (
								<Link to={this.props.shareDetails.matterLink}>
									{this.props.shareDetails.matterName}
								</Link>
							)
						)}
						{PropertyValue(
							"Has Recipient Downloaded?",
							this.props.shareDetails.hasBeenDownloaded
								? `Yes: ${mediumDateFormat(
										this.props.shareDetails.shareAccessedAt
									)}`
								: "No"
						)}
						{PropertyValue("Recipients")}
						<div
							className="GreyContainer"
							style={{
								marginLeft: 12,
								maxHeight: 300,
								overflow: "auto",
							}}
						>
							{this.props.shareDetails.recipients.map(
								(email, index) => (
									<div key={index}>{email}</div>
								)
							)}
						</div>
					</div>
					<div
						style={{
							bottom: 0,
							position: "absolute",
							marginLeft: 12,
							display: "flex",
						}}
					>
						<div style={{ marginRight: 8 }}>
							<ButtonWithIcon
								handler={() =>
									this.props.revokeShare(
										this.props.shareDetails.id,
										"ExternalShareDetail"
									)
								}
								buttonText="Revoke Share"
								disabled={
									getActionDisableMessage({
										canSeeAllShares:
											this.props.canSeeAllShares,
										cognitoSub: this.props.cognitoSub,
										record: this.props.shareDetails,
										userAction: "revoke",
									}) !== undefined
								}
								disabledHoverText={
									getActionDisableMessage({
										canSeeAllShares:
											this.props.canSeeAllShares,
										cognitoSub: this.props.cognitoSub,
										record: this.props.shareDetails,
										userAction: "revoke",
									}) || ""
								}
								iconComponent={
									<IconCancel
										size={16}
										style={{ verticalAlign: "sub" }}
									/>
								}
							/>
						</div>
						<div style={{ marginRight: 8 }}>
							<ButtonWithIcon
								buttonText={getResendButtonText(
									this.props.shareDetails,
									"Re-send Share Email"
								)}
								iconComponent={
									<IconShare2
										size={16}
										style={{ verticalAlign: "sub" }}
									/>
								}
								disabled={
									getActionDisableMessage({
										canSeeAllShares:
											this.props.canSeeAllShares,
										cognitoSub: this.props.cognitoSub,
										record: this.props.shareDetails,
										userAction: "resend",
									}) !== undefined
								}
								disabledHoverText={
									getActionDisableMessage({
										canSeeAllShares:
											this.props.canSeeAllShares,
										cognitoSub: this.props.cognitoSub,
										record: this.props.shareDetails,
										userAction: "resend",
									}) || ""
								}
								handler={() =>
									this.props.resendShare(
										this.props.shareDetails.id,
										"ExternalShareDetail"
									)
								}
							/>
						</div>
					</div>
				</div>
				<div style={{ minWidth: 0 }}>
					{PropertyValue("Documents Shared")}
					<ScrollableListOfFiles
						documentList={this.props.shareDetails.documentList}
					/>
					{PropertyValue(
						<div style={{ color: "#666666", marginTop: 10 }}>
							{this.props.shareDetails.documentCount} documents
							total
						</div>
					)}
					{this.props.shareDetails.sharePassword ? (
						<div
							style={{
								marginLeft: 12,
								marginBottom: 12,
								marginTop: -20,
							}}
						>
							<InfoRow
								label="Share Password"
								value={this.props.shareDetails.sharePassword}
								revealable
							/>
						</div>
					) : null}
					{PropertyValue("Message to Recipients")}

					<div
						className="GreyContainer"
						style={{
							marginTop: 10,
							height: 260,
							overflow: "auto",
							whiteSpace: "pre",
						}}
					>
						{this.props.shareDetails.message}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: state.share.loading,
	shareDetails: state.share.shareDetails,
	shareEmails: state.share.shareEmails,
	publicSharePage: state.share.publicSharePage,
	cognitoSub: state.user.cognitoUser.attributes.sub,
	canSeeAllShares: state.user.userRights.CAN_SEE_ALL_SHARES,
});
const ExternalShareDetail = connect(mapStateToProps, {
	getShareDetailUser,
	revokeShare,
	resendShare,
	openValueCopyDialog,
})(ShareDetail);

export { ExternalShareDetail };
